export default {
  'service_catalog.label.singular': 'Service',
  'service_catalog.page.title': 'Services',

  // Errors
  'service_catalog.errors.loading.service_list':
    'There was a problem loading services',
  'service_catalog.errors.loading.reliability_report':
    'There was a problem loading the reliability report',

  // Empty state
  'service_catalog.empty_state.no_services': 'No Services',
  'service_catalog.empty_state.no_results': 'No Results',
  'service_catalog.empty_state.define_service1': 'Define a service',
  'service_catalog.empty_state.define_service2':
    'to get started with Reliability Management',

  // list forms
  'service_catalog.forms.search.fields.search.options.production': 'Production',
  'service_catalog.forms.search.fields.search.tooltip.none_selected':
    'Select services in the list below to add a Health Check',
  'service_catalog.forms.add_status_check.tooltip.none_available1':
    'Create a Health Check',
  'service_catalog.forms.add_status_check.tooltip.none_available2':
    'to add to your service(s)',

  // add health checks
  'service_catalog.status_checks.modal.title.text':
    'Add Health Check to {{serviceCount}} Service(s)?',
  'service_catalog.status_checks.modal.message.text':
    '{{statusCheckName}} will be added to all selected Service(s)',
  'service_catalog.status_checks.modal.cancel.button.label': 'Cancel',
  'service_catalog.status_checks.modal.add.button.label': 'Add',

  // delete service
  'service_catalog.delete_service.button.text': 'Delete',
  'service_catalog.delete_service.modal.title.text':
    'Delete {{serviceCount}} Service(s)?',
  'service_catalog.delete_service.modal.message.text':
    'Are you sure you want to delete {{serviceCount}} Service(s)?',
  'service_catalog.delete_service.modal.cancel.button.label': 'Cancel',
  'service_catalog.delete_service.modal.delete.button.label': 'Delete',

  // list
  'service_catalog.list.empty_text': 'No Services',
  'service_catalog.list.owned_by': 'Owned by {{firstName}} {{lastName}}',
  'service_catalog.list.shared_namespace_indicator':
    'This service was created with object(s) shared by Team, {{teamName}}. Running a test on this service may impact that Team’s services as well.',
  'service_catalog.list.headers.name': 'Name',
  'service_catalog.list.headers.score': 'Score',
  'service_catalog.list.headers.tags': 'Tags',
  'service_catalog.list.headers.status_checks': 'Health Checks',
  'service_catalog.list.headers.risks': 'Risks',
  'service_catalog.list.fields.tags.production': 'Production',
  'service_catalog.list.fields.status_checks.missing_status_check':
    'Missing Health Check',

  // api call
  'service_catalog.add_status_check.error':
    'There was a problem adding a Health Check to your Service(s)',
  'service_catalog.add_status_check.success':
    'Added the Health Check to your Service(s)',
  'service_catalog.delete_service.success':
    'Successfully deleted your Service(s)',
  'service_catalog.delete_service.error':
    'There was a problem deleting your Service(s)'
}
